import axios from 'axios';
import { API_ENDPOINTS, API_CONFIG } from '@/constants/apiConfig';

const api = axios.create({
  baseURL: API_CONFIG.BASE_URL || '',
  timeout: API_CONFIG.TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
});

export interface EmailConfig {
  id: number;
  daily_processing_limit: number;
  is_active: boolean;
  created_at?: string;
  created_by?: string | null;
  updated_at?: string;
  email_id?: string | null;
}

export interface ApiResponse<T> {
  data: T;
  message: string;
}

class EmailProcessService {
  /**
   * Fetches the email configuration details
   */
  static async getEmailConfig(): Promise<ApiResponse<EmailConfig>> {
    try {
      const response = await api.get<ApiResponse<EmailConfig>>(API_ENDPOINTS.EMAILS.CONFIG_DETAILS);
      return response.data;
    } catch (error) {
      console.error('Error fetching email config:', error);
      throw error;
    }
  }

  /**
   * Updates the email configuration
   * @param configId - The ID of the configuration to update
   * @param data - The new configuration data
   */
  static async updateEmailConfig(
  configId: number | string,
  data: {
    daily_processing_limit: number;
    is_active: boolean;
    email_id: string | null;
  }
): Promise<ApiResponse<EmailConfig>> {
    try {
      const response = await api.post<ApiResponse<EmailConfig>>(
        API_ENDPOINTS.EMAILS.UPDATE_CONFIG(configId),
        { ...data, id: configId }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating email config:', error);
      throw error;
    }
  }
}

export default EmailProcessService;
